
import {Component, Ref} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import AuthMixin from "../../mixins/auth.mixin";
import {IUser, UserLevel, UserLevels} from "shared/entities/user";
import {Api} from "shared/api";
import {Optional} from "utility-types";
import {apiHandler} from "@/services/api-handler";
import AddUser from "@/components/add-user.vue";
import EditUser from "@/components/edit-user.vue";
import {ILocation} from "shared/entities/location";
@Component({components: {EditUser, AddUser}})
export default class ManageUsers extends mixins(AuthMixin) {
    locationsProp: ILocation[] = [];
    allLocations: ILocation[] = [];
    users: IUser[] = [];
    currentSort: keyof IUser = "firstName";
    currentDirection: "asc" | "desc" = "asc";
    currentFilters: Optional<IUser> = {};
    UserLevel = UserLevel;
    currentPage = 1;
    linesPerPage = 10;
    @Ref("add-user") addUser!: AddUser;
    @Ref("edit-user") editUserModal!: EditUser;

    async mounted() {
        await this.refreshUsers();
        await this.fetchLocations(); // Fetch locations on component mount
    }

    async fetchLocations() {
    try {
        const response = await Api.locations.Get();
        if (Array.isArray(response)) { // Check if the response is an array
            this.locationsProp = response; // Assign the response directly to locationsProp
        } else {
           // eslint-disable-next-line no-console
            console.error("Invalid or empty response from API");
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch locations:", error);
    }
    }


   // Create a method to update locationsProp
   updateLocations(newLocations: ILocation[]) {
    this.locationsProp = newLocations;
  }

getLocationName(locationId: number) {
    const location = this.allLocations.find(loc => loc.id === locationId);
    return location ? location.name : "Unknown";
}

    get levels() {
        if (this.user?.level !== UserLevel.Admin)
            return UserLevels.filter(level => level < (this.user?.level ?? 0)).map(level => ({level, title: UserLevel[level]}));
        else
            return UserLevels.map(level => ({level, title: UserLevel[level]}));
    }

    get locationsWithBlank() {
    // Start with a single blank option, followed by actual location options
    return [{ id: "", name: "" }, ...this.locationsProp];
}



    get levelsWithBlank() {
        const levels: {level: UserLevel|null, title: string}[] = this.levels;
        levels.unshift({level: null, title: ""});
        return levels;
    }

    get userDisplay() {
    return this.users
        .filter(u => {
            for (const fk of Object.keys(this.currentFilters) as Array<keyof IUser>) {
                const filterPropValue = this.currentFilters[fk];
                const userPropValue = u[fk];
                if (filterPropValue === "" || filterPropValue === null || filterPropValue === undefined) continue;

                // Adjusted location filter logic
                if (fk === "locations" && Array.isArray(userPropValue)) {
                    // Assuming filterPropValue is the selected location ID and userPropValue is an array of location objects
                    return userPropValue.some(location => location.id.toString() === filterPropValue.toString());
                }

                if (typeof userPropValue === "string" && typeof filterPropValue === "string") {
                    if (!userPropValue.toLowerCase().startsWith(filterPropValue.toLowerCase())) {
                        return false;
                    }
                } else if (typeof userPropValue === "object" && typeof filterPropValue === "object" &&
                    userPropValue !== null && userPropValue.hasOwnProperty("id") && filterPropValue.hasOwnProperty("id")) {
                    if (userPropValue.id !== filterPropValue.id) {
                        return false;
                    }
                } else if (userPropValue !== filterPropValue) {
                    return false;
                }
            }
            return true;
        })
        .sort((a: IUser, b: IUser) => {
            const av = a[this.currentSort]?.toString() ?? "";
            const bv = b[this.currentSort]?.toString() ?? "";
            if (this.currentDirection === "asc") return av.localeCompare(bv);
            else return bv.localeCompare(av);
        })
        .slice((this.currentPage - 1) * this.linesPerPage, this.currentPage * this.linesPerPage);
}

    get numPages() {
    if (!this.userDisplay) {
        // eslint-disable-next-line no-console
        console.error("this.userDisplay is undefined or null");
        return 0;
    }

    if (!Array.isArray(this.userDisplay)) {
        // eslint-disable-next-line no-console
        console.error("this.userDisplay is not an array");
        return 0;
    }

    return Math.ceil(this.userDisplay.length / this.linesPerPage);
}

    get owners() {
        return this.users.filter(user => user.level === UserLevel.Owner);
    }

    async refreshUsers() {
    try {
        const response = await apiHandler(() => Api.user.Get());
        if (response && Array.isArray(response)) {
            this.users = response;
        } else {
             // eslint-disable-next-line no-console
            console.error("Failed to fetch users:", response.error);
            alert("Failed to fetch users. Please try again later.");
        }
    } catch (error) {
         // eslint-disable-next-line no-console
        console.error("An error occurred while fetching users:", error);
        alert("An error occurred while fetching users. Please try again later.");
    }
}


    sort(key: keyof IUser) {
        this.currentDirection = this.currentSort === key ? this.currentDirection === "asc" ? "desc" : "asc" : "asc";
        this.currentSort = key;
    }

    showAddUser() {
        this.addUser.show();
    }

    async resetCompletions(user: IUser) {
        if (!confirm(`Are you sure you want to clear ${user.firstName} ${user.lastName}'s progress?`)) {
            return;
        }

        await apiHandler(() => Api.user[user.id].reset.Post());
        alert("User has been reset.");
    }

    async deleteUser(user: IUser) {
        if (!confirm(`Are you sure you want to delete ${user.firstName} ${user.lastName}`)) return;
        await apiHandler(() => Api.user[user.id].Delete());
        alert("The user has been deleted.");
        await this.refreshUsers();
    }

    async showEditUser(user: IUser) {
        this.editUserModal.show(user);
    }

    getLocationNames(locations) {
        if (!locations || !Array.isArray(locations)) return "No Locations";
        return locations.map(loc => loc.name).join(", ");
    }
}

